import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

const rootEl = document.getElementById("root");

const app = (
    <BrowserRouter>
      <App />
    </BrowserRouter>
);

if (rootEl && rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, app);
} else if (rootEl) {
  createRoot(rootEl).render(app);
}

reportWebVitals();
